module.exports = "img/photo36.5c6676.jpg";